import { useMemo } from 'react'

import { FDInput } from './FDInput'
import { FDInvestmentJourneyResponseType } from '../../../types/fd-type'

export const InputStep = ({
  data,
  currentInvestment,
  handleDisableButton,
  handleInputRelatedAmounts
}: {
  data: FDInvestmentJourneyResponseType | undefined
  handleDisableButton: (isDisable: boolean) => void
  currentInvestment: number
  handleInputRelatedAmounts: ({
    currInvestment,
    matureAmount
  }: {
    currInvestment: number
    matureAmount: number
  }) => void
}) => {
  const timePeriodInYears = useMemo(() => {
    return data?.tenure ? data.tenure / 365 : 0
  }, [data])

  if (data) {
    return (
      <div className='flex flex-col px-5 w-full'>
        <div className='text-white text-[32px] font-[500] leading-[120%] text-center w-full'>
          How much do you want to invest?
        </div>
        <div className='pt-8 w-full'>
          <FDInput
            annualInterestRate={data?.interestRate}
            timePeriodInYears={timePeriodInYears}
            minAmount={data?.minInvestableAmount}
            maxAmount={data?.maxInvestableAmount}
            handleDisableButton={handleDisableButton}
            currentInvestment={currentInvestment}
            handleInputRelatedAmounts={handleInputRelatedAmounts}
          />
        </div>
      </div>
    )
  }

  return null
}
